import React from "react";

const VoucherGraphic = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="3103"
      height="1526"
      fill="none"
      viewBox="0 0 3103 1526"
    >
      <path
        fill="#EF9926"
        fillRule="evenodd"
        d="M643 1037c0 55 45 100 100 100s100-45 100-100-45-100-100-100-100 45-100 100zm30 0c0-39 31-70 70-70s70 32 70 70c0 39-31 70-70 70s-70-31-70-70z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FFEB97"
        fillRule="evenodd"
        d="M2876 552c0 19 16 35 35 35s35-16 35-35-16-35-35-35-35 16-35 35zm10 0c0-14 11-25 25-25s25 11 25 25-11 25-25 25-25-11-25-25z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#EA3F3F"
        fillRule="evenodd"
        d="M1043 1465c0 23 18 41 41 41 22 0 41-18 41-41s-18-41-41-41-41 18-41 41zm12 0c0-16 13-29 29-29s29 13 29 29-13 29-29 29-29-13-29-29z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FFAE1F"
        d="M2527 1004c24.85 0 45-20.147 45-45s-20.15-45-45-45-45 20.147-45 45 20.15 45 45 45zM665 491c19.33 0 35-15.67 35-35s-15.67-35-35-35-35 15.67-35 35 15.67 35 35 35z"
      ></path>
      <path
        fill="#FFD522"
        d="M2183 279c22.09 0 40-17.909 40-40s-17.91-40-40-40-40 17.909-40 40 17.91 40 40 40zM123 1286c22.091 0 40-17.91 40-40s-17.909-40-40-40-40 17.91-40 40 17.909 40 40 40zM2937 1353c16.57 0 30-13.43 30-30s-13.43-30-30-30-30 13.43-30 30 13.43 30 30 30z"
      ></path>
      <path
        fill="#E54242"
        d="M917 868c24.853 0 45-20.147 45-45s-20.147-45-45-45-45 20.147-45 45 20.147 45 45 45zM1916 30c8.28 0 15-6.716 15-15 0-8.284-6.72-15-15-15-8.28 0-15 6.716-15 15 0 8.284 6.72 15 15 15zM330 1165c8.284 0 15-6.72 15-15 0-8.28-6.716-15-15-15-8.284 0-15 6.72-15 15 0 8.28 6.716 15 15 15zM1049 1072c8.28 0 15-6.72 15-15 0-8.28-6.72-15-15-15-8.28 0-15 6.72-15 15 0 8.28 6.72 15 15 15z"
      ></path>
      <path
        fill="#FFAE1F"
        d="M2228 907c8.28 0 15-6.716 15-15 0-8.284-6.72-15-15-15-8.28 0-15 6.716-15 15 0 8.284 6.72 15 15 15z"
      ></path>
      <path
        fill="#FFC91F"
        d="M1078 120c8.28 0 15-6.716 15-15 0-8.284-6.72-15-15-15-8.28 0-15 6.716-15 15 0 8.284 6.72 15 15 15z"
      ></path>
      <path
        fill="#EF4B4B"
        d="M1631 234c13.81 0 25-11.193 25-25s-11.19-25-25-25-25 11.193-25 25 11.19 25 25 25zM3044 1107c13.81 0 25-11.19 25-25s-11.19-25-25-25-25 11.19-25 25 11.19 25 25 25z"
      ></path>
      <path
        fill="#E54242"
        d="M2404 796c13.81 0 25-11.193 25-25s-11.19-25-25-25-25 11.193-25 25 11.19 25 25 25z"
      ></path>
      <path
        fill="#FFAE1F"
        d="M2688 1344l-103-107-104 57-14-26 124-68 98 102 162-151 20 22-183 171z"
      ></path>
      <path
        fill="#EF4B4B"
        d="M2547 567l-14-148h148l-46-160 170-9-46-118 37-15 66 169-174 11 46 162h-157l10 105-40 3z"
      ></path>
      <path
        fill="#FFAE1F"
        d="M920 521l-28-10 50-155-137-60 58-145-164-40 8-30 197 49-60 150 135 60-59 181z"
      ></path>
      <path
        fill="#FFE669"
        d="M219 950l-83-174L33 926 0 904l143-208 87 184 92-100 83 139-34 20-56-93-96 104z"
      ></path>
      <path
        fill="#FFAE1F"
        d="M445 535c-88-58-59-178-58-183l29 7c0 1-24 104 46 151l-17 25zM2950 872l-26-15c53-91 174-69 179-68l-5 29c-1 0-105-19-148 54zM834 1327l-28-10c0-1 40-104 162-91l-3 30c-99-11-130 70-131 71z"
      ></path>
      <path
        fill="#CC3232"
        d="M2218 1526l-28-11c13-31 14-58 3-81-16-33-52-46-52-46l9-29c2 1 49 16 70 62 15 30 14 66-2 105zM1177 232l-14-26c29-16 47-36 54-60 9-35-11-68-12-69l25-16c1 2 28 44 15 92-8 32-31 59-68 79z"
      ></path>
      <path
        fill="#EF4B4B"
        d="M2433 1177c-128-24-159-141-160-146l29-7-15 4 15-4c1 4 28 104 136 124l-5 29z"
      ></path>
      <path
        fill="#FFAE1F"
        d="M2233 407c-17 11 174-15 258-242 7-19-80-80-101-55-21 26 40 164-157 297z"
      ></path>
      <path
        fill="#E54242"
        d="M1125 661s1 592 14 613c13 22 499 244 516 239l-3-633-527-219z"
      ></path>
      <path fill="#FFAE1F" d="M1309 1363s43 64 137 64V830l-137-63v596z"></path>
      <path
        fill="#FFAE1F"
        d="M1446 930V830l-137-63v123c45 16 91 30 137 40z"
        opacity="0.2"
      ></path>
      <path
        fill="#C13838"
        d="M1647 883l8 630s471-228 475-253c5-24 17-624 17-624l-500 247z"
      ></path>
      <path
        fill="#EF9926"
        d="M1869 1408s83-10 124-64l14-592-141 43 3 613z"
      ></path>
      <path
        fill="#EF9926"
        d="M2003 923l4-171-141 43 1 177c46-16 91-32 136-49z"
        opacity="0.17"
      ></path>
      <path
        fill="#EF4B4B"
        d="M1078 578s-4 134 1 152 586 258 599 262c0 0-4-163-4-169 0-7-596-245-596-245z"
      ></path>
      <path
        fill="#D33C3C"
        d="M1674 823l4 169s497-202 504-226c4-12 15-165-4-164l-504 221z"
      ></path>
      <path
        fill="#E54242"
        d="M1674 823l504-221s-530-204-555-204c-25 1-546 179-546 179l597 246z"
      ></path>
      <path
        fill="#FFAE1F"
        d="M1326 494l583 227 11 171s77 8 116-51l-10-172-588-213s-82 1-112 38z"
      ></path>
      <path
        fill="#FFC91F"
        d="M1809 462s83-1 124 46l-509 212-2 165s-113-12-146-62l4-162 529-199z"
      ></path>
      <path
        fill="#FFE424"
        fillRule="evenodd"
        d="M2015 269c-211-225-403 262-357 309 63 64 580-71 357-309zm-343 297c-8-11 164-430 298-255 156 205-285 272-298 255z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FFBB24"
        d="M2037 296c0 5-1 9-2 14-5 38-19 69-34 102-3 15-10 29-19 41-2 5-5 8-9 10-69 75-237 106-288 105-11 2-21 2-32 3 1 3 2 5 4 7 61 62 541-60 380-282z"
        opacity="0.18"
      ></path>
      <path
        fill="#FFE424"
        fillRule="evenodd"
        d="M1659 561c32-14 34-293-115-223-158 74 71 243 115 223zm-101-193c101-60 103 181 97 185-10 6-215-115-97-185z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FFBB24"
        d="M1527 347c-1 2-1 5-2 7-5 20-4 38-3 57-2 8-1 16 1 24 0 3 1 5 2 7 19 50 96 99 121 109 5 3 10 5 15 8l-3 3c-41 18-254-137-131-215z"
        opacity="0.18"
      ></path>
      <path
        fill="#FFE424"
        fillRule="evenodd"
        d="M1661 577c46-47-146-534-357-309-224 238 294 373 357 309zm-312-267c134-176 306 243 298 255-13 17-454-50-298-255z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FFBB24"
        d="M1281 295c0 5 1 9 2 14 5 38 19 69 34 102 3 15 10 29 19 41 2 5 5 8 9 10 69 75 237 106 288 105 11 2 21 2 32 3-1 3-2 5-4 7-61 62-541-60-380-282z"
        opacity="0.18"
      ></path>
      <path
        fill="#FFE424"
        fillRule="evenodd"
        d="M1792 438c-90-75-139 118-119 134 26 21 214-55 119-134zm-115 129c-4-4 41-170 100-110 68 69-94 116-100 110z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FFBB24"
        d="M1802 448v5c0 15-4 27-8 40 0 6-2 11-5 16-1 2-2 3-3 4-22 31-84 51-103 54l-12 3c1 1 1 2 2 2 25 20 200-49 129-124z"
        opacity="0.18"
      ></path>
      <path
        fill="#FFE424"
        d="M1367 675c38-18 76-33 117-44 19-5 11-34-8-29-43 12-84 28-124 47-18 9-2 35 15 26zM1310 711c-2 21-3 43-5 64-1 19 29 19 30 0 2-21 3-43 5-64 1-19-29-19-30 0z"
        opacity="0.48"
      ></path>
      <path
        fill="#FFC91F"
        d="M1815 643l135 45c18 6 26-23 8-29l-135-45c-19-6-27 23-8 29zM1977 713c0 21 0 43-1 64-1 19 29 19 30 0 1-21 2-42 1-64 0-20-30-20-30 0zM1336 1202c0 25 0 50 1 76 0 19 30 19 30 0 0-25 0-50-1-76 0-20-30-20-30 0zM1336 1026c0 41 1 82 1 124 0 19 30 19 30 0 0-41-1-82-1-124 0-19-30-19-30 0z"
        opacity="0.45"
      ></path>
      <path
        fill="#FFAE1F"
        d="M1951 972c-1 59-2 119-2 178 0 19 30 19 30 0 0-59 0-119 2-178 1-19-29-19-30 0zM1950 1207c-2 26-2 52 2 78 2 19 32 19 30 0-3-26-4-52-2-78 2-19-28-19-30 0z"
        opacity="0.51"
      ></path>
      <path
        fill="#EF4B4B"
        d="M1185 595c39-12 78-25 116-39 18-7 10-36-8-29-38 14-77 27-116 39-19 6-11 34 8 29zM1151 828c-2 71-2 143 0 214 1 19 31 19 30 0-2-71-2-143 0-214 1-20-29-20-30 0zM1153 1091c-1 24-1 48 0 73 0 19 30 19 30 0v-73c0-19-30-19-30 0z"
      ></path>
    </svg>
  );
};

export default VoucherGraphic;
